__turbopack_context__.v({
  "container": "C3aLpa_container",
  "variant--desktop": "C3aLpa_variant--desktop",
});
